import { render, staticRenderFns } from "./Award.vue?vue&type=template&id=8ea39326&scoped=true"
import script from "./Award.vue?vue&type=script&lang=js"
export * from "./Award.vue?vue&type=script&lang=js"
import style0 from "./Award.vue?vue&type=style&index=0&id=8ea39326&prod&scoped=scoped&lang=less"
import style1 from "./Award.vue?vue&type=style&index=1&id=8ea39326&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea39326",
  null
  
)

export default component.exports